import { CloudUpload } from "@mui/icons-material"
import useCancelUploadPrompt from "hooks/upload-cancel-prompt"
import HomeHeader from "modules/home-header"
import { Creators } from "./model"

interface Props {
  account: string
}

export default function WatchlistPositionsHeader({ account }: Props) {
  const promptCancel = useCancelUploadPrompt(`/${account}/home/resources`, Creators.resetUpload)

  return <HomeHeader account={account} Icon={CloudUpload} title="Manage Securities" onLogoClick={promptCancel} />
}
